import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "filter-visibility-menu flex flex-col relative" };
const _hoisted_2 = { class: "icon-badge-wrapper flex items-center justify-center w-full h-full" };
const _hoisted_3 = { class: "filter-menu" };
const _hoisted_4 = { class: "filter-toggle-section sticky top-0 z-10 bg-background" };
const _hoisted_5 = { class: "gap-2 px-2 flex" };
const _hoisted_6 = { class: "my-auto w-4 h-4" };
const _hoisted_7 = { class: "filter-list-container max-h-[300px] overflow-y-auto" };
const _hoisted_8 = { class: "filter-list" };
const _hoisted_9 = { class: "filter-list-item flex flex-row items-center gap-4 py-[0.3rem] px-[0.5rem] rounded-[0.3rem] hover:bg-en-blue-100" };
const _hoisted_10 = {
    key: 1,
    class: "filter-reset-section bg-background py-0.5"
};
const _hoisted_11 = { class: "flex gap-2 px-2" };
const _hoisted_12 = { class: "button-text ml-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["EnMenu"], {
            ref: "menuComponent",
            "offset-y": "",
            class: "p-1 z-2500"
        }, {
            trigger: _withCtx(() => [
                _createVNode($setup["EnButton"], {
                    class: "filter-visibility-menu-button flex items-center justify-center relative",
                    size: "icon",
                    tooltip: $setup.t('common.filters.manageFilters'),
                    id: "filter-visibility-menu-button",
                    "static-id": "filter-visibility-menu",
                    "tooltip-location": "bottom",
                    onClick: $setup.handleClick
                }, {
                    icon: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode($setup["ListFilter"], { size: 15 }),
                            _createVNode($setup["EnOverlayBadge"], {
                                count: $setup.activeFilterCount,
                                class: "z-2"
                            }, null, 8 /* PROPS */, ["count"])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["tooltip"])
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    _createCommentVNode(" Sticky Toggle Button at the Top "),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode($setup["EnButton"], {
                            class: "filter-toggle-btn w-full h-auto justify-start gap-2 py-[0.4rem] px-[0.8rem]",
                            variant: "ghost",
                            id: $setup.allFiltersVisible ? 'hide-all-filters-button' : 'show-all-filters-button',
                            onClick: $setup.toggleAllFilters
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        ($setup.allFiltersVisible)
                                            ? (_openBlock(), _createBlock($setup["EyeOff"], {
                                                key: 0,
                                                size: 16
                                            }))
                                            : (_openBlock(), _createBlock($setup["Eye"], {
                                                key: 1,
                                                size: 16
                                            }))
                                    ]),
                                    _createElementVNode("span", null, _toDisplayString($setup.allFiltersVisible ? $setup.t('common.filters.hideAllFilters') : $setup.t('common.filters.showAllFilters')), 1 /* TEXT */)
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["id"])
                    ]),
                    _createVNode($setup["MenuSeparator"]),
                    _createCommentVNode(" Scrollable Filter List "),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.filterButtons, (filterButton) => {
                                return (_openBlock(), _createBlock($setup["EnItem"], {
                                    key: filterButton.id,
                                    class: "p-0 cursor-pointer",
                                    onClick: ($event) => ($setup.toggleIndividualFilter(filterButton))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createVNode($setup["EnCheckboxButton"], {
                                                "model-value": filterButton.visible,
                                                id: filterButton.id,
                                                color: "primary",
                                                density: "compact"
                                            }, null, 8 /* PROPS */, ["model-value", "id"]),
                                            _createElementVNode("div", null, _toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]),
                    ($setup.anyFiltersVisible)
                        ? (_openBlock(), _createBlock($setup["MenuSeparator"], { key: 0 }))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Sticky Reset Button at the Bottom "),
                    ($setup.anyFiltersVisible)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode($setup["EnButton"], {
                                class: "flex p-0 -mb-2 w-full justify-start",
                                variant: "ghost",
                                "static-id": "clear-filters-button",
                                onClick: $setup.clearFilters
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createVNode($setup["FunnelX"], {
                                            size: 16,
                                            class: "my-auto"
                                        }),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString($setup.t('common.filters.clearFilters')), 1 /* TEXT */),
                                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "px-2" }, null, -1 /* CACHED */))
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]),
            _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */)
    ]));
}
